'use client'

import { datadogLogs } from '@datadog/browser-logs'

import { env } from '~/env.js'
import { isFrontEndTelemetryEnabled } from '~/utils/is-front-end-telemetry-enabled.ts'

const clientToken = env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN

if (isFrontEndTelemetryEnabled() && clientToken) {
  const site = env.NEXT_PUBLIC_DATADOG_SITE ?? 'datadoghq.com'
  const service = env.NEXT_PUBLIC_DATADOG_SERVICE ?? 'magicsky-frontend'

  datadogLogs.init({
    clientToken,
    site,
    service,
    env: env.NEXT_PUBLIC_DATADOG_ENV ?? 'development',
    version: env.NEXT_PUBLIC_DATADOG_VERSION,
    forwardConsoleLogs: ['debug', 'info', 'warn', 'error'],
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}

/**
 * Datadog Browser Logs component.
 * Importing this component triggers log collection initialization via module-level code above.
 * When initialized alongside RUM, logs are automatically correlated with RUM sessions.
 * The component itself renders nothing.
 */
export function DatadogLogs() {
  return null
}
